(function () {
  if (customElements.get('spec-compare')) return;

  class SpecCompare extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = this.readData();
      this.emptyToken = (this.data && this.data.empty) || '-';
      this.selects = Array.from(this.querySelectorAll('[data-spec-compare-select]'));
      this.moreButton = this.querySelector('[data-spec-compare-more]');
      this.bind();
      this.tagIncludedRows();
      this.syncCrossSeries();
      this.refreshEmptyRows();
      this.syncMoreButton();
    }

    readData() {
      var node = this.querySelector('[data-spec-compare-json]');
      if (!node) return { products: {} };
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return { products: {} };
      }
    }

    bind() {
      this.selects.forEach(function (select) {
        select.addEventListener('change', this.onSelect.bind(this));
      }.bind(this));

      if (this.moreButton) {
        this.moreButton.addEventListener('click', this.toggleFold.bind(this));
      }

      this.addEventListener('click', this.onBuy.bind(this));
    }

    onSelect(event) {
      var select = event.currentTarget;
      var col = Number(select.getAttribute('data-col'));
      var handle = select.value;
      var product = this.data.products[handle];
      if (!product) return;

      this.updateCard(col, product);
      this.updateCells(col, product);
      this.syncSelectState();
      this.syncCrossSeries();
      this.refreshEmptyRows();
    }

    productFamily(handle) {
      var value = String(handle || '').toLowerCase();
      if (value.indexOf('avata-360') !== -1 || value.indexOf('avata360') !== -1) return 'avata-360';
      if (value.indexOf('avata-2') !== -1 || value.indexOf('avata2') !== -1) return 'avata-2';
      return value;
    }

    tagIncludedRows() {
      var inIncluded = false;
      this.querySelectorAll('.spec-compare__group, .spec-compare__row').forEach(function (node) {
        if (node.classList.contains('spec-compare__group')) {
          var text = (node.textContent || '').replace(/['’]/g, '').toLowerCase();
          inIncluded = text.indexOf('included') !== -1;
        }
        if (inIncluded) node.setAttribute('data-group', 'included');
      });
    }

    syncCrossSeries() {
      this.tagIncludedRows();
      var left = this.selects[0] ? this.selects[0].value : '';
      var right = this.selects[1] ? this.selects[1].value : '';
      var cross = Boolean(left && right && this.productFamily(left) !== this.productFamily(right));
      this.classList.toggle('is-cross-series', cross);
      this.querySelectorAll('[data-group="included"]').forEach(function (node) {
        node.hidden = cross;
        node.classList.toggle('is-included-hidden', cross);
      });
    }

    updateCard(col, product) {
      var root = this.querySelector('.spec-compare__product[data-col="' + col + '"]');
      if (!root) return;

      root.querySelectorAll('[data-spec-compare-link]').forEach(function (link) {
        link.setAttribute('href', product.url || '#');
      });

      var image = root.querySelector('[data-spec-compare-image]');
      if (image) {
        if (product.image) {
          image.src = product.image;
          image.alt = product.imageAlt || product.title || '';
          image.hidden = false;
        } else {
          image.hidden = true;
        }
      }

      var title = root.querySelector('[data-spec-compare-title]');
      if (title) title.textContent = product.title || '';

      var colTitle = this.querySelector('[data-spec-compare-col-title][data-col="' + col + '"]');
      if (colTitle) colTitle.textContent = product.title || '';

      var price = root.querySelector('[data-spec-compare-price]');
      if (price) price.textContent = product.price || '';

      var compare = root.querySelector('[data-spec-compare-compare]');
      if (compare) {
        if (product.compareAt) {
          compare.hidden = false;
          compare.textContent = product.compareAt;
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      var buyWrap = root.querySelector('[data-spec-compare-buy-wrap]');
      if (buyWrap) {
        var url = product.url || '#';
        var shopTrack = this.safeTrackClass(product.trackShop);
        var shopClass = 'spec-compare__buy button button--primary' + (shopTrack ? ' ' + shopTrack : '');
        if (product.hasOptions) {
          buyWrap.innerHTML = '<a class="' + shopClass + '" href="' + url.replace(/"/g, '&quot;') + '" data-spec-compare-link>Buy Now</a>';
        } else if (product.available) {
          buyWrap.innerHTML = '<button type="button" class="' + shopClass + '" data-spec-compare-buy data-variant-id="' + String(product.variantId || '') + '">Buy Now</button>';
        } else {
          buyWrap.innerHTML = '<button type="button" class="' + shopClass + '" data-spec-compare-buy disabled>Sold out</button>';
        }
      }

      var learn = root.querySelector('[data-spec-compare-learn]');
      if (learn) {
        var keep = (learn.className || '').split(/\s+/).filter(function (name) {
          return name && name.indexOf('series-') !== 0;
        });
        var lmTrack = this.safeTrackClass(product.trackLm);
        if (lmTrack) keep.push(lmTrack);
        learn.className = keep.join(' ');
      }
    }

    safeTrackClass(value) {
      if (!value || typeof value !== 'string') return '';
      return value.replace(/[^a-zA-Z0-9_-]/g, '');
    }

    updateCells(col, product) {
      var cells = this.querySelectorAll('.spec-compare__val[data-col="' + col + '"]');
      cells.forEach(function (cell) {
        var row = cell.closest('.spec-compare__row');
        var label = row ? row.getAttribute('data-label') : '';
        var value = (product.cells && Object.prototype.hasOwnProperty.call(product.cells, label))
          ? product.cells[label]
          : this.emptyToken;
        var nextValue = value || this.emptyToken;
        cell.textContent = nextValue;
        cell.classList.toggle('is-dash', nextValue === this.emptyToken);
      }.bind(this));
    }

    syncSelectState() {
      var selected = this.selects.map(function (select) {
        return select.value;
      });
      this.selects.forEach(function (select, index) {
        Array.from(select.options).forEach(function (option) {
          var taken = selected.some(function (handle, handleIndex) {
            return handleIndex !== index && handle === option.value;
          });
          option.disabled = taken;
          if (taken) option.setAttribute('disabled', 'disabled');
          else option.removeAttribute('disabled');
          if (option.value === select.value) option.setAttribute('selected', 'selected');
          else option.removeAttribute('selected');
        });

        var wrap = select.closest('.spec-compare__switcher');
        var nice = wrap ? wrap.querySelector('.nice-select') : select.nextElementSibling;
        if (!nice || !nice.classList.contains('nice-select')) return;
        var current = select.options[select.selectedIndex];
        var label = nice.querySelector('.current');
        if (label && current) label.textContent = current.textContent.trim();
        nice.querySelectorAll('.option').forEach(function (item) {
          var value = item.getAttribute('data-value');
          item.classList.toggle('disabled', selected.some(function (handle, handleIndex) {
            return handleIndex !== index && handle === value;
          }));
          item.classList.toggle('selected', value === select.value);
        });
      });
    }

    refreshEmptyRows() {
      this.querySelectorAll('.spec-compare__row[data-label]').forEach(function (row) {
        var values = Array.from(row.querySelectorAll('.spec-compare__val')).map(function (cell) {
          return (cell.textContent || '').trim();
        });
        var empty = values.every(function (value) {
          return !value || value === this.emptyToken;
        }.bind(this));
        row.classList.toggle('is-empty-row', empty);
      }.bind(this));
      this.syncMoreButton();
      this.refreshPeek();
    }

    refreshPeek() {
      this.querySelectorAll('.is-peek').forEach(function (node) {
        node.classList.remove('is-peek');
      });
      if (this.classList.contains('is-expanded')) return;
      var first = this.querySelector(this.foldedSelector());
      if (first) first.classList.add('is-peek');
    }

    foldedSelector() {
      if (this.classList.contains('is-cross-series')) {
        return '.spec-compare__row.is-folded:not(.is-empty-row):not([data-group="included"]), .spec-compare__group.is-folded:not([data-group="included"])';
      }
      return '.spec-compare__row.is-folded:not(.is-empty-row), .spec-compare__group.is-folded';
    }

    foldedTargets() {
      return this.querySelectorAll(this.foldedSelector());
    }

    syncMoreButton() {
      if (!this.moreButton) return;
      var hasFold = this.foldedTargets().length > 0;
      this.moreButton.hidden = !hasFold;
      if (!hasFold) {
        this.classList.remove('is-expanded');
        var more = this.moreButton.querySelector('[data-label-more]');
        var less = this.moreButton.querySelector('[data-label-less]');
        if (more) more.hidden = false;
        if (less) less.hidden = true;
      }
    }

    toggleFold() {
      var expanded = this.classList.toggle('is-expanded');
      var more = this.moreButton.querySelector('[data-label-more]');
      var less = this.moreButton.querySelector('[data-label-less]');
      if (more) more.hidden = expanded;
      if (less) less.hidden = !expanded;
      this.refreshPeek();
    }

    onBuy(event) {
      var button = event.target.closest('[data-spec-compare-buy]');
      if (!button || button.hidden || !this.contains(button) || button.disabled) return;
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
      event.preventDefault();
      this.addToCart(variantId, button);
    }

    openCartDrawer(cartDrawer) {
      if (!cartDrawer) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.click();
        return;
      }
      cartDrawer.classList.remove('is-empty');
      var inner = cartDrawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
      else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }

    prepareCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof window.loadTemplateContent === 'function') {
        window.loadTemplateContent(cartDrawer);
      }
      return Promise.resolve(document.querySelector('cart-drawer') || cartDrawer);
    }

    addToCart(variantId, button) {
      var cartNotification = document.querySelector('cart-notification');
      var cartItems = document.querySelector('cart-items');
      button.disabled = true;

      return this.prepareCartDrawer().then(function (cartDrawer) {
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sections = cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          });
        }
        if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
          if (typeof window.loadTemplateContent === 'function') window.loadTemplateContent(cartNotification);
          sections = sections.concat(cartNotification.getSectionsToRender().map(function (section) {
            return section.id;
          }));
        }
        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          sections = sections.concat(cartItems.getSectionsToRender().map(function (section) {
            return section.section;
          }));
        }
        sections = sections.filter(Boolean).filter(function (id, index, list) {
          return list.indexOf(id) === index;
        });

        var body = new FormData();
        body.append('id', String(variantId));
        body.append('quantity', '1');
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);

        var config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = body;

        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'add failed');
            var atcAction = window.theme && theme.settings && theme.settings.cartDrawer && theme.settings.cartDrawer.atcAction;
            if (atcAction === 'page') {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return data;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cartData: data,
                productVariantId: Number(variantId),
              });
            }
            try {
              if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
                cartDrawer.renderContents(data);
              }
            } catch (e) {}
            try {
              if (cartItems && typeof cartItems.renderContents === 'function' && data.sections) {
                cartItems.renderContents(data);
              }
            } catch (e) {}
            this.openCartDrawer(cartDrawer);
            return data;
          }.bind(this));
      }.bind(this)).catch(function () {
      }).finally(function () {
        button.disabled = false;
      });
    }
  }

  customElements.define('spec-compare', SpecCompare);
})();
